import React from 'react';
import { useIntl } from 'react-intl';
import { Alert } from 'react-bootstrap';
import { useAppData } from 'contexts/appContext';

export const enum GlobalAlertEvent {
  ALERT = 'alert',
  CLOSE = 'close'
}

export interface GlobalAlertProps {
  message: string;
  show: boolean;
  variant: string;
}

export interface parseMessageProps {
  message: string;
  variant: string;
}

export const GlobalAlertInitState = {
  message: 'default.alert.info',
  show: false,
  variant: 'success'
}

export const alertReducer = (state, action) => {
  switch (action.type) {
    case GlobalAlertEvent.ALERT:
      return parseInput(action.payload.message);
    case GlobalAlertEvent.CLOSE:
      return { ...state, show: false};
    default:
      return state;
  }
}

function parseInput(message: string | parseMessageProps) {
  switch (typeof message) {
    case "string":
      return {...parseMessage(message), show:true}
    case "object":
      return {...message, show:true}
  } 
}

function parseMessage(message: string) {
  const msgArr = message.split('.');
  const alertIdx = msgArr.indexOf('alert');
  if (alertIdx === -1) {
    console.error(`Incorrect alert message format. The format should contain alert.variant.messageID in the locales file. \n\n Expected: componentName.alert.variant.messageID\n Received: ${message}\n`); 
    return GlobalAlertInitState;
  }
  return {
    variant: msgArr[alertIdx + 1],
    message: message,
  }
}

export const GlobalAlert = () => {
  const intl = useIntl();
  const { alertState, closeAlert } = useAppData();

  return (
    <Alert
      variant={alertState.variant}
      show={alertState.show}
      onClose={() => closeAlert()}
      dismissible
    >
       {intl.formatMessage({ id: alertState.message })}
    </Alert>
  );
};

export default GlobalAlert;